// Simple InfoPage component with iframe
import React from 'react';

const InfoPage: React.FC = () => {
  return (
    <div className="w-full" style={{ minHeight: 'calc(100vh - 200px)' }}>
      <iframe
        src="/info/index.html"
        width="100%"
        height="600px"
        style={{ border: 'none', minHeight: '600px' }}
        title="Info Page"
      />
    </div>
  );
};

export default InfoPage;